export const NO_SCHEDULE_TEXT = 'Not Scheduled';

export const SYNC_ON_DEMAND_WARNING_BANNER_TITLE = 'Caution while Syncing the Pipeline';

export const SYNC_ON_DEMAND_WARNING_BANNER_DESCRIPTION =
  'For Log based pipelines there is a possibility of Log expiry or Pipeline getting disabled due to Log size monitoring. If the incremental syncs are not scheduled accurately';
